/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clipboard_Copy_Errortitle1Inputs */

const en_clipboard_copy_errortitle1 = /** @type {(inputs: Clipboard_Copy_Errortitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy`)
};

/**
* | output |
* | --- |
* | "Failed to copy" |
*
* @param {Clipboard_Copy_Errortitle1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const clipboard_copy_errortitle1 = /** @type {((inputs?: Clipboard_Copy_Errortitle1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clipboard_Copy_Errortitle1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_clipboard_copy_errortitle1(inputs)
});
export { clipboard_copy_errortitle1 as "clipboard_copy_errorTitle" }